module.exports = __webpack_public_path__ + "img/clock.24b7ee24.svg";